import { render, staticRenderFns } from "./ButtonsFinalSessionResult.vue?vue&type=template&id=b6e835d0&scoped=true&"
import script from "./ButtonsFinalSessionResult.vue?vue&type=script&lang=js&"
export * from "./ButtonsFinalSessionResult.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsFinalSessionResult.vue?vue&type=style&index=0&id=b6e835d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e835d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
